/* global require */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Header, Item, Picker, View } from 'native-base';
import { Col, Grid } from 'react-native-easy-grid';
import { Image, Dimensions, TouchableOpacity, Text } from 'react-native';
import { styles, C, PROJECT_TITLE } from '../../constants';
import { openURL } from '../../_helpers';
import { Button } from 'native-base';
import Icon from 'react-native-vector-icons/MaterialIcons';

let deviceWidth = Dimensions.get('window').width;

import {
    sendLogout, 
    setAppRegion,  
    // setCheckerId,
    getBlockByUrl,
    // setAppRegion
} from '../../actions';
import {translations as t} from '../../constants/translations';
import {sideMenuStyle} from "../SideMenu";
import { TextInput } from 'react-native-gesture-handler';
import { Select } from '@material-ui/core';

class AppHeader extends Component {
    constructor(props) {
        super(props);
    }

    state ={ 
        selected: "RU",
        check: false
      }

    onValueChange (value) {
      const { dispatch } = this.props;
      const { selected } = this.state;
      selected === "RU" ? dispatch(setAppRegion("EN")) : dispatch(setAppRegion("RU"));
        this.setState({...this.state, selected : value, check: false });
    }

  handlerExit = () => {
    this.props.dispatch(sendLogout());
  }

  handlerPressLogo = () => {
    openURL("https://rzd-medicine.ru");
  }

  // handlerSubmit = () => {
  //   const { dispatch } = this.props;
  //   // dispatch(setCheckerId(Number(this.state.checkerID)));
  //   // dispatch(getBlockByUrl());
  //   this.setState({
  //     ...this.state, checker: true
  //   });

  //   // this.props.appRegion === "RU" ? dispatch(setAppRegion("EN")) : dispatch(setAppRegion("RU"));
  //   console.log( this.state.selected , "aaaa<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<");
  // };

    closeDrawer = () => {
        this.drawer._root.close();
    };


    openDrawer = () => { this.drawer._root.open(); };

  render() {

      const {appRegion} = this.props;
      const {check} = this.state;
    return (
      <Header style={styles.appHeader}>
        <Grid>
            {!check ?
                // <Col>
                    <Button
                        // onPressIn={()=>{this.props.drawer._root.open();}}
                        onPressIn={()=>this.setState({ ...this.state, check: true})}
                        style={{backgroundColor:'#e2051c'}}
                    >
                        <Icon name="language" style={{color:'#FFFFFF', fontSize:26}}
                        />
                    {/*    <Text>Menu</Text>*/}
                    </Button>
                // </Col>
                : 
                <View style={{width:45, height: 30, borderRadius: 25, marginLeft: 5, marginTop:8}}>
                <Picker 
                  selectedValue={this.state.selected}
                  onValueChange={this.onValueChange.bind(this)}
                  style={{width:45, height: 30, borderRadius: 25, marginLeft: 5, marginTop:8}}>
                  <Picker.Item label="RU" value="RU"/>
                  <Picker.Item label="EN" value="EN"/>
                </Picker>    
              </View>  
            }


          <Col style={styles.appHeaderCol_3}>
              <Text style={styles.appHeaderTitle}>
                  {t[appRegion]['APPHEADER_TITLE']}
              </Text>

              {/* <Item style={{marginLeft: 400}}> */}
               {/* <Text
                            style={{ fontSize: 20, color: 'blue', fontWeight: "bold", marginLeft: "18%"}}
                          > {t[appRegion]['SIDEMENU_ITEM_LANGUAGE']}:
                    </Text> */}
                  {/* <Button
                          // sma/ll
                          // full
                          // rounded
                          onPress={this.handlerSubmit}
                          style={{backgroundColor:'#4169E1', paddingLeft:0, height: 40, paddingRight:10, marginLeft: 10, borderRadius:80}}
                      > */}
                          {/* <Text style={{color:'white'}}>{t[appRegion]['APPHEADER_CHECK_BUTTON']}</Text> */}
                    {/* <View>
                   
                      <Picker 
                        selectedValue={this.state.selected}
                        onValueChange={this.onValueChange.bind(this)}
                        style={{width:50, borderRadius: 25, marginLeft: 5,}}>
                        <Picker.Item label="RU" value="RU"/>
                        <Picker.Item label="EN" value="EN"/>
                      </Picker>    
                    </View>        
                 </Button>  */}

                 
                
              {/* </Item> */}
          {/*    <Image*/}
          {/*  resizeMode='contain'*/}
          {/*  source={require('../../../assets/img/corona_logo.png')}*/}
          {/*  style={{*/}
          {/*    minWidth: 108,*/}
          {/*    height: 31,*/}
          {/*    width: "100%"*/}
          {/*  }}*/}
          {/*/>*/}
                  {/* <Item style={{marginLeft: 400}}>
                      <Button
                          // sma/ll
                          // full
                          // rounded
                          onPress={this.handlerSubmit}
                          style={{backgroundColor:'#4169E1', paddingLeft:10, paddingRight:10, height:50}}
                      >
                          <Text style={{color:'white'}}>r32r {t[appRegion]['APPHEADER_CHECK_BUTTON']}</Text>
                      </Button>
                  </Item> */}
          </Col>

        </Grid></Header>
    );
  }
}


AppHeader.propTypes = {
  dispatch: PropTypes.func.isRequired,
  appRegion: PropTypes.object,
};

const mapStateToProps = (state) => ({
    appRegion: state.appRegion
});

export default connect(mapStateToProps)(AppHeader);